module.exports = __webpack_public_path__ + "pc/static/img/find.ec988df0.png";